<template>
  <div>
    <div class="wrapper">
      <b-navbar toggleable="lg" type="light">
        <b-navbar-brand :to="logoRoute">
          <img :src="logo" alt="Logo" class="d-inline-block align-top">
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav v-if="activeApp?.name === 'fms'">
            <!-- Home Link -->
            <b-nav-item :to="{ name: 'Home' }" :class="{ 'selected': $route.name === 'Home' }"
              class="d-flex align-items-center">
              <img :src="$route.name === 'Home' ? icon.IconHomeActive : icon.IconHome" class="mr-2" />
              <span :class="{ 'pink-text': $route.name === 'Home' }">Home</span>
            </b-nav-item>
            <!--/ Home Link -->

            <!-- Dashboard Link -->
            <b-nav-item :to="{ name: 'FmsDashboard' }" :class="{ 'selected': $route.name === 'FmsDashboard' }"
              class="d-flex align-items-center">
              <img :src="icon.IconDashboard" class="mr-2" />
              <span :class="{ 'pink-text': $route.name === 'FmsDashboard' }">Dashboard</span>
            </b-nav-item>
            <!--/ Dashboard Link -->

            <!-- Asset Link -->
            <b-nav-item :to="{ name: 'ReportWrapper' }" :class="{ 'selected': $route.name === 'ReportWrapper' }"
              class="d-flex align-items-center">
              <img :src="icon.IconReport" class="mr-2" />
                <span :class="{ 'pink-text': $route.name === 'FmsReport' }">Report</span>
            </b-nav-item>
            <!--/ Asset Link -->

            <!-- Dashboard Link -->
            <b-nav-item :href="'/weather'" :class="{ 'selected': $route.name === 'Weather' }"
              class="d-flex align-items-center"
              v-if="userAccess.weather && userAccess.weather.find((x) => x === 'read')">
              <img :src="icon.IconWeather" class="mr-2" />
              <span :class="{ 'pink-text': $route.name === 'Weather' }">Weather</span>
            </b-nav-item>
            <!--/ Dashboard Link -->

            <!-- Event Log Link -->
            <b-nav-item v-if="userAccess.log_event_event && userAccess.log_event_event.find((x) => x === 'read')"
              :to="{ name: 'EventLog' }" :class="{ 'selected': $route.name === 'EventLog' }"
              class="d-flex align-items-center">
              <img :src="icon.IconEventLog" class="mr-2" />
              <span :class="{ 'pink-text': $route.name === 'EventLog' }">Event Log</span>
            </b-nav-item>
            <!--/ Event Log Link -->

            <!-- Home Link -->
            <b-nav-item :to="{ name: 'Voyage' }" :class="{ 'selected': $route.name === 'Voyage' }"
              class="d-flex align-items-center">
              <img :src="$route.name === 'Voyage' ? icon.IconVoyage : icon.IconVoyage" class="mr-2" />
              <span :class="{ 'pink-text': $route.name === 'Voyage' }">Voyage</span>
            </b-nav-item>
            <!--/ Home Link -->
          </b-navbar-nav>

          <b-navbar-nav v-if="activeApp?.name === 'bunkering'">
            <!-- Home Link -->
            <b-nav-item v-if="canRead('master_bunker_log')" :to="{ name: 'BunkerDashboard' }" :class="{ 'selected': $route.name === 'BunkerDashboard' }"
              class="d-flex align-items-center">
              <img :src="icon.IconHome" class="mr-2" />
              <span :class="{ 'pink-text': $route.name === 'BunkerDashboard' }">Home</span>
            </b-nav-item>
            <!--/ Home Link -->

            <!-- Bunker Log Link -->
            <b-nav-item v-if="canRead('master_bunker_log')" :to="{ name: 'BunkeringLog' }" :class="{ 'selected': $route.name === 'BunkeringLog' }"
              class="d-flex align-items-center">
              <img :src="icon.IconBunkeringLog" class="mr-2" />
              <span :class="{ 'pink-text': $route.name === 'BunkeringLog' }">Bunker Log</span>
            </b-nav-item>
            <!--/ Bunker Log Link -->

            <!-- Remain On Board -->
            <b-nav-item v-if="canRead('master_rob_rob')" :to="{ name: 'RemainOnBoard' }" :class="{ 'selected': $route.name === 'RemainOnBoard' }"
              class="d-flex align-items-center">
              <img :src="icon.IconROB" class="mr-2" />
              <span :class="{ 'pink-text': $route.name === 'RemainOnBoard' }">Remain On Board</span>
            </b-nav-item>
            <!-- Remain On Board -->
          </b-navbar-nav>

          <b-navbar-nav class="navbar-actions ml-auto d-flex align-items-center">

            <!-- Select Company and App Dropdown -->
            <b-nav-item-dropdown v-if="!hideCompanySelection" text="Options" right>
              <template #button-content>
                <img :src="icon.IconSelection" class="mr-2" style="width: 18px; height: 18px;">
                <span>Select App/Company</span>
              </template>
              <b-dropdown-item v-on:click="openSelectAppModal">
                <img :src="icon.IconApp" alt="App Icon" class="mr-2" style="width: 22px; height: 22px;">
                Select Application
              </b-dropdown-item>
              <b-dropdown-item v-on:click="openSelectCompanyModal">
                <img :src="icon.IconCompany" alt="Company Icon" class="mr-2">
                Select Company
              </b-dropdown-item>
            </b-nav-item-dropdown>
            <!--/ Select Company and App Dropdown -->

            <!-- Notification Dropdown -->
            <b-nav-item-dropdown v-if="canRead('master_notification')" class="d-flex align-items-center navbar-action-item notification-dropdown" right no-caret menu-class="notification-dropdown-menu">
              <template #button-content>
                <span class="notification-trigger" v-b-tooltip.hover title="Notifications">
                  <i class="ri-notification-3-line"></i>
                  <span
                    v-if="totalUnreadCount"
                    class="notification-badge"
                    :class="{ 'notification-badge-pulse': hasAnyDanger }">
                    {{ totalUnreadCount > 99 ? '99+' : totalUnreadCount }}
                  </span>
                </span>
              </template>

              <div class="notification-panel">
                <div class="notification-header">
                  <span>Notifications</span>
                  <span v-if="totalUnreadCount" class="notification-count-pill">
                    {{ totalUnreadCount }}
                  </span>
                </div>

                <div v-if="isAnyNotificationLoading && !totalUnreadCount" class="notification-empty">
                  <b-spinner small variant="primary" />
                  <p>Loading notifications...</p>
                </div>

                <div v-else-if="!totalUnreadCount" class="notification-empty">
                  <i class="ri-check-double-line"></i>
                  <p>You're all caught up</p>
                </div>

                <div v-else class="notification-list">
                  <!-- Expiration Section -->
                  <div v-if="notifications.length" class="notification-section">
                    <button
                      type="button"
                      class="notification-section-header"
                      :aria-expanded="sectionExpanded.expiration ? 'true' : 'false'"
                      @click.stop.prevent="toggleSection('expiration')">
                      <span class="notification-section-title">Subscription Expiration</span>
                      <span class="notification-section-meta">
                        <span class="notification-section-count">{{ unreadNotificationsCount }}</span>
                        <span
                          class="notification-section-arrow"
                          :class="{ collapsed: !sectionExpanded.expiration }"
                          aria-hidden="true">&#9662;</span>
                      </span>
                    </button>
                    <div v-show="sectionExpanded.expiration">
                      <b-dropdown-item
                        v-for="notification in notifications"
                        :key="notification.id"
                        class="notification-item notification-item-unread"
                        :class="`notification-${notification.severity}`"
                        @click="handleNotifClick(notification)">
                        <div class="notification-status" aria-hidden="true"></div>
                        <div class="notification-content">
                          <div v-if="notification.shipName" class="notification-ship">{{ notification.shipName }}</div>
                          <div class="notification-title">{{ notification.title }}</div>
                          <div class="notification-message">{{ notification.message }}</div>
                          <div class="notification-time">Expired at: {{ formatNotifDate(notification.time) }}</div>
                        </div>
                      </b-dropdown-item>
                    </div>
                  </div>

                  <!-- Event Section -->
                  <div v-if="canRead('log_event_event') && eventNotifications.length" class="notification-section">
                    <button
                      type="button"
                      class="notification-section-header"
                      :aria-expanded="sectionExpanded.events ? 'true' : 'false'"
                      @click.stop.prevent="toggleSection('events')">
                      <span class="notification-section-title">Events</span>
                      <span class="notification-section-meta">
                        <span class="notification-section-count">{{ eventUnreadCount }}</span>
                        <span
                          class="notification-section-arrow"
                          :class="{ collapsed: !sectionExpanded.events }"
                          aria-hidden="true">&#9662;</span>
                      </span>
                    </button>
                    <div v-show="sectionExpanded.events">
                      <b-dropdown-item
                        v-for="notification in eventNotifications"
                        :key="notification.id"
                        class="notification-item notification-item-unread"
                        :class="`notification-${notification.severity}`"
                        @click="openEventDetail(notification)">
                        <div class="notification-status" aria-hidden="true"></div>
                        <div class="notification-content">
                          <div v-if="notification.shipName" class="notification-ship">{{ notification.shipName }}</div>
                          <div class="notification-title">
                            {{ notification.title }}
                            <b-badge
                              :variant="notification.status === 'Active' ? 'danger' : 'secondary'"
                              class="ml-1 align-middle event-notif-badge">
                              {{ notification.status }}
                            </b-badge>
                          </div>
                          <div class="notification-message">
                            Duration {{ formatEventDuration(notification.duration) }}
                          </div>
                          <div class="notification-time">At: {{ formatEventTime(notification.time) }}</div>
                        </div>
                      </b-dropdown-item>
                    </div>
                  </div>
                </div>

                <div v-if="totalUnreadCount" class="notification-footer-group">
                  <button
                    v-if="notifications.length"
                    type="button"
                    class="notification-footer notification-footer-split"
                    @click.stop="handleViewAll">
                    Expired Assets
                  </button>
                  <button
                    v-if="eventNotifications.length"
                    type="button"
                    class="notification-footer notification-footer-split"
                    @click.stop="goToEventLog">
                    Event Log
                  </button>
                </div>
              </div>
            </b-nav-item-dropdown>
            <!--/ Notification Dropdown -->

            <!-- Config Button -->
            <b-nav-item :to="{ name: 'MasterConfiguration' }"
              :class="{ 'selected': $route.name === 'MasterConfiguration' }"
              class="d-flex align-items-center navbar-action-item" v-b-tooltip.hover title="Configuration">
              <i class="ri-settings-3-line" style="font-size: 1.5rem;"
                :class="{ 'pink-text': $route.name === 'MasterConfiguration' }"></i>
            </b-nav-item>

            <!-- dropdown user -->
            <b-nav-item-dropdown class="d-flex align-items-center navbar-action-item" right>
              <!-- Using 'button-content' slot -->
              <template #button-content>
                <img :src="profileImage" class="mr-2" :style="{ width: '25px', height: '25px' }">
                <span class="truncate">{{ userId }}</span>
              </template>
              <b-dropdown-item href="#">Profile</b-dropdown-item>
              <b-dropdown-item @click="handleLogout">Sign Out</b-dropdown-item>
            </b-nav-item-dropdown>
            <!--/ dropdown user -->
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <b-modal id="select-app-modal" title="Select App" centered hide-footer>
        <app-active-selection maxWidth=true hideHeader=true maxHeight=true />
      </b-modal>

      <b-modal id="select-company-modal" title="Select Company" centered hide-footer>
        <company-active-selection maxWidth=true hideHeader=true disableRedirection=true maxHeight=true />
      </b-modal>

      <!-- Event Detail Modal -->
      <b-modal size="lg" hide-footer no-close-on-esc no-close-on-backdrop v-model="isOpenEventDetail">
        <template #modal-header>
          <div class="d-flex align-items-center flex-wrap">
            <h5 class="modal-title mr-2 mb-0">{{ selectedEvent ? selectedEvent.title : 'Event Detail' }}</h5>
            <b-badge
              v-if="selectedEvent"
              :variant="selectedEvent.status === 'Active' ? 'danger' : 'secondary'"
              class="mr-2">
              {{ selectedEvent.status }}
            </b-badge>
            <b-badge
              v-if="selectedEvent"
              :variant="selectedEvent.priority === 'High' ? 'warning' : 'info'">
              {{ selectedEvent.priority }} priority
            </b-badge>
          </div>
          <b-button variant="outline-danger" size="sm" @click="closeEventDetail">
            <i class="ri-close-fill"></i>
          </b-button>
        </template>

        <b-container class="my-2" v-if="selectedEvent">
          <b-row class="mb-3 text-muted small">
            <b-col cols="12" md="6"><strong>Time:</strong> {{ formatEventTime(selectedEvent.time) }}</b-col>
            <b-col cols="12" md="6"><strong>Duration:</strong> {{ formatEventDuration(selectedEvent.duration) }}</b-col>
            <b-col cols="12" md="6" class="mt-1"><strong>Ship:</strong> {{ selectedEvent.shipName || '-' }}</b-col>
            <b-col cols="12" md="6" class="mt-1"><strong>Device ID:</strong> {{ selectedEvent.deviceId || '-' }}</b-col>
          </b-row>

          <h6 class="mt-3 mb-2">Data Changes</h6>
          <b-table
            v-if="parsedEventDetail.dataRows.length"
            :items="parsedEventDetail.dataRows"
            :fields="eventDataFields"
            striped hover small responsive>
            <template #cell(device)="data">
              <strong>{{ data.item.device }}</strong>
            </template>
            <template #cell(type)="data">
              <span class="text-primary">{{ data.item.type }}</span>
            </template>
          </b-table>
          <div v-else class="text-muted small mb-2">No data changes recorded.</div>

          <h6 class="mt-4 mb-2">Thresholds</h6>
          <div v-if="Object.keys(parsedEventDetail.thresholds).length">
            <b-card
              v-for="(item, name) in parsedEventDetail.thresholds"
              :key="name"
              class="mb-2">
              <template #header>
                <div class="d-flex justify-content-between align-items-center">
                  <strong>{{ name }}</strong>
                  <b-badge v-if="item.conditions_operator" variant="info">
                    {{ item.conditions_operator }}
                  </b-badge>
                </div>
              </template>
              <b-table
                small
                :items="formatThresholdRows(item.data)"
                :fields="thresholdFields"
                responsive="sm" bordered head-variant="light" class="mb-0" />
            </b-card>
          </div>
          <div v-else class="text-muted small">No threshold information.</div>
        </b-container>
      </b-modal>
      <!--/ Event Detail Modal -->

      <div>
        <transition name="router-anim">
          <router-view :key="$store.state.remountKey" />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import logo from '@/assets/images/Mantraz-logo.svg';
import profileImage from '@/assets/images/user/default-user.png';
// import { sofbox } from '@/config/pluginInit';

import AppActiveSelection from '@/views/auth/AppActiveSelection';
import CompanyActiveSelection from '@/views/auth/CompanyActiveSelection';

import IconHome from '../assets/images/navbar/home.svg';
import IconWeather from '../assets/images/navbar/weather.svg';
import IconHomeActive from '../assets/images/navbar/home-active.svg';
import IconDashboard from '../assets/images/navbar/dashboard.svg';
import IconDashboardActive from '../assets/images/navbar/dashboard-active.svg';
import IconEventLog from '../assets/images/navbar/event-log.svg';
import IconReport from '../assets/images/navbar/report.svg';
import IconReportActive from '../assets/images/navbar/report-active.svg';
import IconAsset from '../assets/images/navbar/asset.svg';
import IconAssetActive from '../assets/images/navbar/asset-active.svg';
import IconCompany from '../assets/images/navbar/company.svg';
import IconSelection from '../assets/images/navbar/selection.svg';
import IconApp from '../assets/images/navbar/application.svg';
import IconDevice from '../assets/images/navbar/device.svg';
import IconLandmarks from '../assets/images/navbar/landmarks.svg';
import IconBunkeringLog from '../assets/images/navbar/bunkering-log.svg';
import IconBunkeringLogActive from '../assets/images/navbar/bunkering-log-active.svg';
import IconROB from '../assets/images/navbar/rob.svg';
import IconVoyage from '../assets/images/navbar/voyage.svg';

export default {
  name: 'AuthorizedLayout',
  components: {
    AppActiveSelection,
    CompanyActiveSelection,
  },
  computed: {
    ...mapState(['remountKey']),
    activeCompany() {
      return this.$store.getters['auth/activeCompany'];
    },
    userAccess() {
      const access = this.$store.getters['auth/userAccess'];
      return access;
    },
    userId() {
      return this.$store.getters['auth/userId'];
    },
    activeApp() {
      return this.$store.getters['auth/activeApp'];
    },
    logoRoute() {
      if (this.activeApp?.name === 'bunkering') {
        return { name: 'BunkerDashboard' };
      }

      return { name: 'Home' };
    },
    notifications() {
      return this.$store.getters['notification/notifications'];
    },
    unreadNotificationsCount() {
      return this.$store.getters['notification/unreadCount'];
    },
    isNotificationLoading() {
      return this.$store.getters['notification/loading'];
    },
    eventNotifications() {
      return this.$store.getters['eventNotification/notifications'];
    },
    eventUnreadCount() {
      return this.$store.getters['eventNotification/unreadCount'];
    },
    isEventNotificationLoading() {
      return this.$store.getters['eventNotification/loading'];
    },
    totalUnreadCount() {
      return this.unreadNotificationsCount + this.eventUnreadCount;
    },
    isAnyNotificationLoading() {
      return this.isNotificationLoading || this.isEventNotificationLoading;
    },
    hasAnyDanger() {
      return this.notifications.some((n) => n.severity === 'danger')
        || this.eventNotifications.some((n) => n.severity === 'danger');
    },
    parsedEventDetail() {
      if (!this.selectedEvent) return { dataRows: [], thresholds: {} };
      const raw = this.selectedEvent.raw || {};
      const oldData = this.safeJsonParse(raw.evntOldData) || {};
      const newData = this.safeJsonParse(raw.evntNewData) || {};
      const thresholds = this.safeJsonParse(raw.evntThreshold) || {};

      const dataRows = [];
      const devices = new Set([
        ...Object.keys(oldData),
        ...Object.keys(newData),
      ]);
      devices.forEach((device) => {
        const types = new Set([
          ...Object.keys(oldData[device] || {}),
          ...Object.keys(newData[device] || {}),
        ]);
        types.forEach((type) => {
          const dataNames = new Set([
            ...Object.keys((oldData[device] || {})[type] || {}),
            ...Object.keys((newData[device] || {})[type] || {}),
          ]);
          dataNames.forEach((dataName) => {
            dataRows.push({
              device,
              type,
              dataName,
              oldValue: (oldData[device] || {})[type]?.[dataName] ?? '-',
              newValue: (newData[device] || {})[type]?.[dataName] ?? '-',
            });
          });
        });
      });

      return { dataRows, thresholds };
    },
  },
  data() {
    return {
      hideCompanySelection: false,
      logo,
      profileImage,
      isSmallSidebar: false,
      availableCompany: [],
      notificationPollMs: 5 * 60 * 1000,
      eventNotificationPollMs: 60 * 1000,
      isOpenEventDetail: false,
      selectedEvent: null,
      sectionExpanded: {
        expiration: true,
        events: true,
      },
      eventDataFields: [
        { key: 'device', label: 'Device' },
        { key: 'type', label: 'Type' },
        { key: 'dataName', label: 'Data Name' },
        { key: 'oldValue', label: 'Old Value' },
        { key: 'newValue', label: 'New Value' },
      ],
      thresholdFields: [
        { key: 'parameter', label: 'Parameter' },
        { key: 'operator', label: 'Operator' },
        { key: 'value', label: 'Value' },
      ],
      icon: {
        IconHome,
        IconWeather,
        IconHomeActive,
        IconDashboard,
        IconDashboardActive,
        IconReport,
        IconReportActive,
        IconAsset,
        IconAssetActive,
        IconCompany,
        IconSelection,
        IconApp,
        IconDevice,
        IconLandmarks,
        IconBunkeringLog,
        IconBunkeringLogActive,
        IconEventLog,
        IconROB,
        IconVoyage,
      },
    };
  },
  mounted() {
    // sofbox.mainIndex();
    this.availableCompany = this.$store.getters['auth/availableCompany'];

    const availableCompaniesCount = Object.values(this.$store.getters['auth/availableCompany']).length;
    if (availableCompaniesCount === 1) this.hideCompanySelection = true;

    if (this.canRead('master_notification')) {
      this.$store.dispatch('notification/fetch');
      this._notifPoll = setInterval(() => {
        this.$store.dispatch('notification/fetch');
      }, this.notificationPollMs);

      if (this.canRead('log_event_event')) {
        this.$store.dispatch('eventNotification/fetch');
        this._eventNotifPoll = setInterval(() => {
          this.$store.dispatch('eventNotification/fetch');
        }, this.eventNotificationPollMs);
      }
    }
  },
  beforeDestroy() {
    if (this._notifPoll) clearInterval(this._notifPoll);
    if (this._eventNotifPoll) clearInterval(this._eventNotifPoll);
  },
  methods: {
    onMaxMinSidebar() {
      this.isSmallSidebar = !this.isSmallSidebar;
    },
    handleLogout() {
      this.$store.dispatch('auth/logout');
      window.location.href = '/auth/login';
    },
    openSelectAppModal() {
      this.$bvModal.show('select-app-modal');
    },
    openSelectCompanyModal() {
      this.$bvModal.show('select-company-modal');
    },
    formatNotifDate(dateStr) {
      if (!dateStr) return '-';
      return new Date(dateStr).toLocaleDateString('id-ID', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      });
    },
    handleNotifClick(notification) {
      if (notification.massId && this.$route.name !== 'Asset') {
        this.$router.push({
          name: 'Asset',
          query: { highlight: notification.massId },
        });
      }
    },
    handleViewAll() {
      if (this.$route.name === 'Asset' && this.$route.query.subscriptionFilter === 'expired') return;
      this.$router.push({
        name: 'Asset',
        query: { subscriptionFilter: 'expired' },
      });
    },
    openEventDetail(notification) {
      this.selectedEvent = notification;
      this.isOpenEventDetail = true;
    },
    toggleSection(name) {
      this.sectionExpanded = {
        ...this.sectionExpanded,
        [name]: !this.sectionExpanded[name],
      };
    },
    closeEventDetail() {
      this.isOpenEventDetail = false;
      this.selectedEvent = null;
    },
    formatEventTime(dateStr) {
      if (!dateStr) return '-';
      const d = new Date(dateStr);
      if (Number.isNaN(d.getTime())) return '-';
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    formatEventDuration(seconds) {
      const s = Number(seconds) || 0;
      const pad = (n) => String(n).padStart(2, '0');
      const h = Math.floor(s / 3600);
      const m = Math.floor((s % 3600) / 60);
      const sec = s % 60;
      return `${pad(h)}:${pad(m)}:${pad(sec)}`;
    },
    formatThresholdRows(data) {
      if (!data || typeof data !== 'object') return [];
      return Object.keys(data).map((key) => ({
        parameter: key,
        operator: data[key]?.operator ?? '-',
        value: data[key]?.value ?? '-',
      }));
    },
    safeJsonParse(str) {
      if (!str) return null;
      if (typeof str !== 'string') return str;
      try {
        return JSON.parse(str);
      } catch (e) {
        return null;
      }
    },
    goToEventLog() {
      if (this.$route.name !== 'EventLog') {
        this.$router.push({ name: 'EventLog' });
      }
    },
  },
  watch: {
    shouldRemount(newValue) {
      if (newValue) {
        console.debug('duar');
        this.$forceUpdate();
      }
    },
  },
};
</script>
<style>
@media (max-width: 991px) {

  .leaflet-top,
  .leaflet-bottom {
    z-index: 400 !important;
  }

  .navbar-collapse {
    left: 0 !important;
    top: 70px !important;
    position: fixed !important;
    width: 100% !important;
    z-index: 1999 !important;
  }

  .navbar-collapse .navbar-nav {
    align-items: flex-start !important;
    height: auto;
    margin-left: 0 !important;
    padding-left: 0 !important;
    width: 100%;
  }

  .navbar-collapse .nav-item {
    align-items: center !important;
    display: flex !important;
    min-height: 41px;
    margin-left: 5px !important;
    margin-right: 5px !important;
  }

  .navbar-collapse .nav-link {
    align-items: center !important;
    display: inline-flex !important;
    min-height: 41px;
    padding: 0 !important;
    text-align: left;
  }

  .navbar-nav .dropdown-menu {
    position: relative !important;
    max-height: 200px !important;
    overflow: scroll !important;
  }

  .navbar-actions {
    align-items: flex-start !important;
    margin-left: 0 !important;
    padding-left: 0 !important;
    width: 100%;
  }

  .navbar-actions .nav-link {
    justify-content: flex-start;
  }
}

.truncate {
  display: inline-block;
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.navbar-brand img {
  width: 72px;
}

.navbar {
  background-color: white;
  padding: 0 1rem !important;
  height: 70px;
  z-index: 999;
}

.navbar-nav {
  height: 100%;
}

.user-profile-image {
  width: 25px;
}

.nav-item {
  margin-left: 5px;
  margin-right: 5px;
}

.nav-link {
  font-size: 14px;
  padding: 0;
  margin: 0;
}

/* Penambahan dimulai di sini */
.navbar-nav .nav-item .nav-link {
  white-space: nowrap;
}
/* Penambahan berakhir di sini */

.nav-link img {
  height: 14px;
}

.nav-link span {
  color: black;
  font-weight: 600;
  letter-spacing: 1.4px;
}

.selected {
  color: #ff69b4;
  position: relative;
}

.selected::after {
  content: "";
  position: absolute;
  width: 100%;
  border-radius: 2px;
  height: 6px;
  bottom: 0px;
  left: 0;
  background-color: #ff69b4;
}

.pink-text {
  color: #ff69b4 !important;
}

.notification-trigger {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  color: #002A64;
}

.notification-trigger i {
  font-size: 1.45rem;
}

.notification-badge {
  position: absolute;
  top: 2px;
  right: 1px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background-color: #ff69b4;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
}

.notification-badge-pulse {
  background-color: #dc3545;
  box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.6);
  animation: mantrazNotifPulse 1.8s ease-out infinite;
}

@keyframes mantrazNotifPulse {
  0% { box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.55); }
  70% { box-shadow: 0 0 0 8px rgba(220, 53, 69, 0); }
  100% { box-shadow: 0 0 0 0 rgba(220, 53, 69, 0); }
}

.notification-dropdown .dropdown-menu {
  width: 360px;
  padding: 0;
  border: 0;
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(0, 42, 100, 0.18);
  overflow: hidden;
}

.notification-panel {
  background-color: #fff;
}

.notification-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #edf1f7;
  color: #002A64;
  font-size: 14px;
  font-weight: 700;
}

.notification-footer {
  border: 0;
  background: transparent;
  color: #ff69b4;
  font-size: 12px;
  font-weight: 700;
}

.notification-count-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 20px;
  padding: 0 8px;
  border-radius: 10px;
  background-color: #ff69b4;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

.notification-list {
  max-height: 360px;
  overflow-y: auto;
}

.notification-item .dropdown-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  white-space: normal;
}

.notification-item-unread .dropdown-item {
  background-color: #f4f8ff;
}

.notification-status {
  flex: 0 0 auto;
  width: 8px;
  height: 8px;
  margin-top: 6px;
  border-radius: 50%;
  background-color: transparent;
}

.notification-item-unread .notification-status {
  background-color: #ff69b4;
}

.notification-empty {
  padding: 28px 16px;
  text-align: center;
  color: #9aa6b2;
}

.notification-empty i {
  display: block;
  font-size: 1.8rem;
  color: #c5cdda;
  margin-bottom: 6px;
}

.notification-empty p {
  margin: 0;
  font-size: 12px;
  color: #6c757d;
}

.notification-content {
  min-width: 0;
}

.notification-title {
  color: #1f2d3d;
  font-size: 13px;
  font-weight: 700;
}

.notification-message {
  margin-top: 3px;
  color: #6c757d;
  font-size: 12px;
  line-height: 1.35;
}

.notification-time {
  margin-top: 5px;
  color: #9aa6b2;
  font-size: 11px;
}

.event-notif-badge {
  font-size: 9px;
  letter-spacing: 0.4px;
}

.notification-danger .notification-status { background-color: #dc3545 !important; }
.notification-warning .notification-status { background-color: #ffc107 !important; }
.notification-info .notification-status { background-color: #17a2b8 !important; }

.notification-section + .notification-section {
  border-top: 1px solid #edf1f7;
}

.notification-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 16px;
  border: 0;
  background-color: #f7f9fc;
  color: #4a5b75;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  cursor: pointer;
  text-align: left;
}

.notification-section-header:focus,
.notification-section-header:focus-visible {
  outline: none;
  background-color: #eef2f8;
}

.notification-section-header:hover {
  background-color: #eef2f8;
}

.notification-section-meta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.notification-section-count {
  min-width: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background-color: #e3eaf5;
  color: #002A64;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
}

.notification-section-arrow {
  display: inline-block;
  color: #4a5b75;
  font-size: 12px;
  line-height: 1;
  transition: transform 0.15s ease;
}

.notification-section-arrow.collapsed {
  transform: rotate(-90deg);
}

.notification-ship {
  color: #002A64;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 2px;
}

.notification-footer-group {
  display: flex;
  border-top: 1px solid #edf1f7;
}

.notification-footer-split {
  flex: 1;
  border: 0;
  background: transparent;
  padding: 12px 16px;
  color: #002A64;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}

.notification-footer-split + .notification-footer-split {
  border-left: 1px solid #edf1f7;
}

.notification-footer-split:hover {
  background-color: #f4f8ff;
  color: #ff69b4;
}

.notification-footer-group .notification-footer {
  border-top: 0;
}

.notification-footer {
  display: block;
  width: 100%;
  padding: 12px 16px;
  border-top: 1px solid #edf1f7;
  color: #002A64;
  text-align: center;
}

@media (max-width: 991px) {
  .notification-dropdown .dropdown-menu {
    width: calc(100vw - 24px);
    max-height: 320px !important;
  }
}
</style>
